import { ApplicationConfig, APP_INITIALIZER, Provider } from '@angular/core';
import { provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withPreloading, NoPreloading } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppInitializerService } from './app-initializer.service';
import { routes } from './app.routes';
import { importProvidersFrom } from '@angular/core';
import { HammerModule } from '@angular/platform-browser';
import { ServiceWorkerModule } from '@angular/service-worker';
import { isPlatformBrowser } from '@angular/common';
import { provideServiceWorker } from '@angular/service-worker';
import { environment } from '../environments/environment';

// Create an initializer function that will be called when the app starts
export function initializeApp(initializer: AppInitializerService) {
  return () => initializer.initialize();
}

// Create a provider for the initializer
export const APP_INITIALIZER_PROVIDER: Provider = {
  provide: APP_INITIALIZER,
  useFactory: initializeApp,
  deps: [AppInitializerService],
  multi: true
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withPreloading(NoPreloading) // Disable default preloading for now
    ),
    provideHttpClient(
      withInterceptorsFromDi()
    ),
    importProvidersFrom(HammerModule),
  
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.enableServiceWorker,
      registrationStrategy: 'registerWhenStable:30000'
    }),
    AppInitializerService,
    APP_INITIALIZER_PROVIDER
  ]
};
